module.exports = __webpack_public_path__ + "images/696c15a90d2749674162187e7a76e1ae.jpg";